import { initializeApp, getApps } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getAuth } from 'firebase/auth';
import { getAnalytics, isSupported } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyDZadI2Iz0NwY6rozzyQGM0qtmz5C6dVNs",
  authDomain: "story-arch.firebaseapp.com",
  databaseURL: "https://story-arch-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "story-arch",
  storageBucket: "story-arch.firebasestorage.app",
  messagingSenderId: "77297185402",
  appId: "1:77297185402:web:64df12654ecfae7d7c01c3"
};
let app;
let database;
let auth;
let analytics = null;

if (!getApps().length) {
  app = initializeApp(firebaseConfig);
  database = getDatabase(app);
  auth = getAuth(app);
  
  // Analytics solo client-side
  if (typeof window !== 'undefined') {
    isSupported().then(yes => {
      if (yes) {
        analytics = getAnalytics(app);
      }
    });
  }
} else {
  app = getApps()[0];
  database = getDatabase(app);
  auth = getAuth(app);
}

export { database as db, auth, analytics };